"use client"

import { useSyncExternalStore } from "react"
import { useSideChatStore } from "@/stores/sideChatStore"
import { SIDE_CHAT_LAYOUT } from "./desktopUI.constants"

const OVERLAY_MEDIA_QUERY = `(max-width: ${SIDE_CHAT_LAYOUT.OVERLAY_BELOW_WIDTH - 1}px)`

function overlayQuery(): MediaQueryList | null {
    if (
        typeof window === "undefined" ||
        typeof window.matchMedia !== "function"
    )
        return null
    return window.matchMedia(OVERLAY_MEDIA_QUERY)
}

function subscribe(onChange: () => void): () => void {
    const query = overlayQuery()
    if (!query) return () => {}
    query.addEventListener("change", onChange)
    return () => query.removeEventListener("change", onChange)
}

function readIsOverlay(): boolean {
    return overlayQuery()?.matches ?? false
}

function readServerIsOverlay(): boolean {
    return false
}

export function useIsSideChatOverlay(): boolean {
    return useSyncExternalStore(subscribe, readIsOverlay, readServerIsOverlay)
}

export function useSideChatInset(): number {
    const isOverlay = useIsSideChatOverlay()
    const isOpen = useSideChatStore(state => state.isOpen)
    return isOpen && !isOverlay ? SIDE_CHAT_LAYOUT.WIDTH : 0
}
